import { render } from "./FuelInvestmentCalculator.vue?vue&type=template&id=33072f44&scoped=true"
import script from "./FuelInvestmentCalculator.vue?vue&type=script&lang=js"
export * from "./FuelInvestmentCalculator.vue?vue&type=script&lang=js"

import "./FuelInvestmentCalculator.vue?vue&type=style&index=0&id=33072f44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33072f44"]])

export default __exports__